export const foodData = [
  {
    category: "Starters",
    name: "Miso Soup",
    price: 5,
    description: "Enoki, tofu, green onion, seaweed, miso paste, hondashi",
    category_fr: "Entrées",
    name_fr: "Soupe Miso",
    description_fr: "Champignon enoki, tofu, algues, pâte de miso, hondashi.",
  },
  {
    category: "Starters",
    name: "Edamame",
    price: 7,
    description:
      "Edamame, sesame oil,white & black sesame seeds, salt, togarashi.",
    category_fr: "Entrées",
    name_fr: "Edamame",
    description_fr:
      "Edamame, huile de sésame, graines de sésame blanches et noires, sel, togarashi.",
  },
  {
    category: "Starters",
    name: "Japanese Salad",
    price: 12,
    description:
      "Green mix, marinated red cabbage, cucumber, kohlrabi, jicama, carrots, watermelon radish, basil, mint, japanese dressing, sprouts.",
    category_fr: "Entrées",
    name_fr: "Salade Japonaise",
    description_fr:
      "Mesclun, chou rouge, concombre, chou-rave, jicama, carotte, basilic, menthe, radis pastèque, pousses, vinaigrette japonaise, choux.",
  },
  {
    category: "Starters",
    name: "Kane Salad",
    price: 16,
    description: "Kani kama, cucumber, spicy mayo, julienne green onions",
    category_fr: "Entrées",
    name_fr: "Salade Kane",
    description_fr:
      "Kani Kama, concombre, mayonnaise épicée, oignons verts en julienne",
  },
  {
    category: "Starters",
    name: "Gyoza Beef - 5 pcs",
    price: 17,
    description: "Ground beef, green onions, gyoza sauce.",
    category_fr: "Entrées",
    name_fr: "Gyoza Au Boeuf - 5 morceaux",
    description_fr: "Bœuf haché, oignon vert, sauce gyoza.",
  },
  {
    category: "Starters",
    name: "Gyoza Fried Seafood - 5 pcs",
    price: 18,
    description: "Seafood mix, green onions, gyoza sauce.",
    category_fr: "Entrées",
    name_fr: "Gyoza Frits Au Fruits De Mer - 5 morceaux",
    description_fr: "Mélange de fruits de mer, oignons verts, sauce gyoza.",
  },
  {
    category: "Starters",
    name: "Salmon & Tuna Tartar",
    price: 31,
    description:
      "Salmon, wasabi mayonnaise, wasabi, masago, tabasco, grated white sesame seeds, chives, yellowfin tuna, tobiko, spicy mayonnaise, dragon sauce.",
    category_fr: "Entrées",
    name_fr: "Tartare Saumon & Thon",
    description_fr:
      "Saumon,mayonnaise au wasabi, wasabi, masago, tabasco, poudre de sésame, ciboulette, Albacore, tobiko,mayonnaise épicée, sauce dragon.",
  },
  {
    category: "Starters",
    name: "Salmon Tartar",
    price: 22,
    description:
      "Salmon, wasabi mayonnaise, wasabi, masago, tabasco, grated white sesame seeds, chives.",
    category_fr: "Entrées",
    name_fr: "Tartare Saumon",
    description_fr:
      "Saumon,mayonnaise au wasabi, wasabi, masago, tabasco, poudre de sésame, ciboulette.",
  },
  {
    category: "Starters",
    name: "Tuna Tartar",
    price: 23,
    description: "Yellowfin tuna, tobiko, spicy mayonnaise, dragon sauce.",
    category_fr: "Entrées",
    name_fr: "Tartare Thon",
    description_fr: "Albacore, tobiko,mayonnaise épicée, sauce dragon.",
  },
  {
    category: "Starters",
    name: "Salmon Nigiri Platter (6)",
    price: 18,
    description:
      "Atlantic salmon, sushi rice, grated sesame seeds, green onions.",
    category_fr: "Entrées",
    name_fr: "Salmon Nigiri Platter (6)",
    description_fr:
      "Saumon de l’Atlantique, riz sushi, poudre de graines de sésame, oignon vert.",
  },
  {
    category: "Starters",
    name: "Shrimp Tempura",
    price: 17,
    description: "Homemade popcorn shrimp, creamy spicy sauce, green onions.",
    category_fr: "Entrées",
    name_fr: "Crevettes Tempura",
    description_fr:
      "Crevettes popcorn tempura, sauce crémeuse épicée, oignon vert.",
  },
  {
    category: "Tacos (3 pcs)",
    name: "Tuna",
    price: 24,
    description:
      "Spiced Tuna tartar, avocado purée, jalapeño, shiso leaves salsa, wonton shell.",
    category_fr: "Tacos (3 pièces)",
    name_fr: "Tuna",
    description_fr:
      "Tartare de thon relevé, purée d’avocat,  jalapeño, salsa de feuille de shiso, coquille de wonton.",
  },
  {
    category: "Tacos (3 pcs)",
    name: "Salmon",
    price: 21,
    description:
      "Spiced salmon tartar, avocado purée, micro coriander, ginger flower salsa,  jalapeño, wonton shell.",
    category_fr: "Tacos (3 pièces)",
    name_fr: "Saumon",
    description_fr:
      "Tartare de saumon relevé, purée d’avocat, mini coriandre, salsa de fleur de gingembre, jalapeño, coquille de wonton.",
  },
  {
    category: "Tacos (3 pcs)",
    name: "Avocado",
    price: 16,
    description:
      "Avocado purée, bell pepper salsa, truffle peaches, jalapeño, sprouts, wonton shell.",
    category_fr: "Tacos (3 pièces)",
    name_fr: "Avocado",
    description_fr:
      "Purée d’avocat, salsa de poivrons, pêche à la truffe, jalapeño, pousses, coquille de wonton.",
  },
  {
    category: "Tataki (6 slices)",
    name: "GRASS FED BEEF",
    price: 26,
    description:
      "Beef filet mignon, truffle peaches, togarashi, maitake mushroom, microgreens, Ponzu sauce.",
    category_fr: "Tataki (6 tranches)",
    name_fr: "Boeuf élevé en plein air",
    description_fr:
      "Filet mignon de bœuf saisi, pêche à la truffe, togarashi, champignons maitakes, micro-pousses, sauce Ponzu.",
  },
  {
    category: "Tataki (6 slices)",
    name: "GRILLED TUNA AKAMI",
    price: 22,
    description:
      "Seared togarashi tuna, red pepper salsa, fried onion, green onions, micro coriander, dragon sauce.",
    category_fr: "Tataki (6 tranches)",
    name_fr: "GRILLED TUNA AKAMI",
    description_fr:
      "Thon poêlé en croûte de togarashi, salsa de poivron rouge, oignon frit, oignon vert, mini coriandre, sauce dragon.",
  },
  {
    category: "Tataki (6 slices)",
    name: "Salmon Tataki",
    price: 18,
    description:
      "Seared salmon, oba salsa, green onions, micro coriander, Ponzu sauce.",
    category_fr: "Tataki (6 tranches)",
    name_fr: "Saumon Tataki",
    description_fr:
      "Saumon de l’Atlantique sasi, salsa d’Oba, pousse de coriandre, sauce Ponzu.",
  },
  {
    category: "Platters (omakase)",
    name: "Nigiri",
    price: ["6pcs / $23", "12pcs / $45", "18pcs / $65"],
    description: "",
    category_fr: "Plateaux (omakase)",
    name_fr: "Nigiri",
    price_fr: ["6 morceaux / 23$", "12 morceaux / 45$", "18 morceaux / 65$"],
    description_fr: "",
  },
  {
    category: "Platters (omakase)",
    name: "Sashimi",
    price: ["12pcs / $45", "24pcs / $85"],
    description: "",
    category_fr: "Plateaux (Omakase)",
    name_fr: "Sashimi",
    price_fr: ["12 morceaux / 45$", "24 morceaux / 85$"],
    description_fr: "",
  },
  {
    category: "Platters (omakase)",
    name: "Premium Sashimi",
    price: ["24pcs / $120"],
    description: "",
    category_fr: "Plateaux (omakase)",
    name_fr: "Premium Sashimi",
    price_fr: ["24 morceaux / 120$"],
    description_fr: "",
  },
  {
    category: "Platters (omakase)",
    name: "Seafood Platters (36 pcs)",
    price: 140,
    description:
      "Black tiger shrimp, Ora king salmon, hamachi, red tuna, lobster tail, oyster, seafood maki.",
    category_fr: "Plateaux (Omakase)",
    name_fr: "Fruits De Mer (36 morceaux)",
    price_fr: 140,
    description_fr:
      "Crevettes, Saumon Ora King, Hamachi, Thon rouge, Queue de homard, huitre, fruit de mer maki.",
  },
  {
    category: "Classic Makis 6 pcs",
    name: "Go Vegan",
    price: 16,
    description:
      "Marinated enoki mushroom, asparagus, avocado, pickled daikon, sushi rice, avocado mix, lotus roots, edamame purée, soya paper, togarashi.",
    category_fr: "Makis Classiques 6 morceaux",
    name_fr: "Go Vegan",
    description_fr:
      "Champignon enoki, pâte de truffes, asperge, avocat, daikon mariné, riz sushi, mix d’avocat, racine de lotus, purée d’edamames, feuille de soja, togarashi.",
  },
  {
    category: "Classic Makis 6 pcs",
    name: "Cali Vision",
    price: 17,
    description:
      "At.salmon tartar, kanikama, avocado, spicy mayo, soya paper, sushi rice, kizami wasabi, green onion, unagi sauce.",
    category_fr: "Makis Classiques 6 morceaux",
    name_fr: "Cali Vision",
    description_fr:
      "Tarte au saumon, kanikama, avocat, mayonnaise épicée, papier de soja, riz à sushi, wasabi kizami, ciboule, sauce unagi.",
  },
  {
    category: "Classic Makis 6 pcs",
    name: "B. 52",
    price: 14,
    description:
      "Salmon or Tuna, cucumber, avocado, tempura, spicy mayo, nori paper, sushi rice, unagi sauce.",
    category_fr: "Makis Classiques 6 morceaux",
    name_fr: "B. 52",
    description_fr:
      "Saumon ou thon, concombre, avocat, tempura, mayonnaise épicée, feuille de nori, riz à sushi, sauce unagi.",
  },
  {
    category: "Classic Makis 6 pcs",
    name: "Double Salmon",
    price: 16,
    description:
      "Salmon, avocado, spicy mayo, nori paper, sushi rice, leamon, unagi sauce.",
    category_fr: "Makis Classiques 6 morceaux",
    name_fr: "Double Saumon",
    description_fr:
      "Saumon, avocat, mayonnaise épicée, feuille de nori, riz à sushi, citron, sauce unagi.",
  },
  {
    category: "Classic Makis 6 pcs",
    name: "Red and White",
    price: 19,
    description:
      "Akami tuna tartar, tuna on the top, avocado, mizuna, tempura, spicy mayo, nori paper, sushi rice, unagi sauce, green onion.",
    category_fr: "Makis Classiques 6 morceaux",
    name_fr: "Rouge et Blanc",
    description_fr:
      "Tartare de thon Akami, thon sur le dessus, avocat, mizuna, tempura, mayonnaise épicée, feuille de nori, riz à sushi, sauce unagi, ciboule.",
  },
  {
    category: "Classic Makis 6 pcs",
    name: "Sakura - 4 pcs",
    price: 19,
    description:
      "Bluefin tuna, salmon, Hamachi, oba leaf, cucumber, pickled daikon, avocado, enoki, Ponzu sauce.",
    category_fr: "Makis Classiques 6 morceaux",
    name_fr: "Sakura - 4 morceaux",
    description_fr:
      "Thon bluefin, saumon, Hamachi, feuille d’Oba, concombre, daikon mariné, avocat, enoki, sauce Ponzu.",
  },
  {
    category: "Ura Makis - 6 pcs",
    name: "Salmon",
    price: 9,
    description: "",
    category_fr: "Ura Makis - 6 morceaux",
    name_fr: "Saumon",
    description_fr: "",
  },
  {
    category: "Ura Makis - 6 pcs",
    name: "Tuna Toro",
    price: 17,
    description: "",
    category_fr: "Ura Makis - 6 morceaux",
    name_fr: "Thon Gras",
    description_fr: "",
  },
  {
    category: "Ura Makis - 6 pcs",
    name: "Hamachi",
    price: 11,
    description: "",
    category_fr: "Ura Makis - 6 morceaux",
    name_fr: "Thon a Queue Jaune",
    description_fr: "",
  },
  {
    category: "Ura Makis - 6 pcs",
    name: "Cucumber",
    price: 6,
    description: "",
    category_fr: "Ura Makis - 6 morceaux",
    name_fr: "Concombre",
    description_fr: "",
  },
  {
    category: "Ura Makis - 6 pcs",
    name: "Scallops",
    price: 15,
    description: "",
    category_fr: "Ura Makis - 6 morceaux",
    name_fr: "Pétoncles",
    description_fr: "",
  },
  {
    category: "Ura Makis - 6 pcs",
    name: "Avocado",
    price: 6,
    description: "",
    category_fr: "Ura Makis - 6 morceaux",
    name_fr: "Avocat",
    description_fr: "",
  },
  {
    category: "Ura Makis - 6 pcs",
    name: "Shrimp & Avocado",
    price: 14,
    description: "",
    category_fr: "Ura Makis - 6 morceaux",
    name_fr: "Crevettes & Avocat",
    description_fr: "",
  },
  {
    category: "Premium Makis 8pcs",
    name: "A5 Miyazaki Wagyu",
    price: 55,
    description:
      "A5 Miyazaki wagyu, mix tartar, enoki mushroom, fried onion, mizuna, soya paper, sushi rice, yakitori tare, black tobiko, kizami wasabi, green onion, unagi sauce",
    category_fr: "Premium Makis 8 morceaux",
    name_fr: "Miyazaki Wagyu A5",
    description_fr:
      "Wagyu Miyazaki A5, tartar, champignons enoki, oignon frit, mizuna, feuille de soja, sauce tare yakitori, tobiko noir, kizami wasabi, oignon vert, sauce unagi.",
  },
  {
    category: "Premium Makis 8pcs",
    name: "Nigi (Rainbow)",
    price: 26,
    description:
      "Mix tartar, salmon, bluefin tuna, Hamachi, tempura, cucumber, wakame, spicy mayonnaise, soya paper, sushi rice, basil mayonnaise, mix flower, japanese spices.",
    category_fr: "Premium Makis 8 morceaux",
    name_fr: "Nigi (Arc-en-ciel)",
    description_fr:
      "Tartare mixte, saumon, thon rouge, Hamachi, tempura, concombre, wakame, mayonnaise épicée, feuille de soja, riz à sushi, mayonnaise au basilic, fleurs mixtes, épices japonaises.",
  },
  {
    category: "Premium Makis 8pcs",
    name: "Toro Maki",
    price: 33,
    description:
      "Mix tartar, chu toro, smoked caviar, Kanikama, avocado, pickled daikon, green onion, nori paper, sushi rice, basil mayonnaise, unagi sauce, sprouts",
    category_fr: "Premium Makis 8 morceaux",
    name_fr: "Toro Maki",
    description_fr:
      "Crabe bleu, Chu toro, caviar fumé, Kanikama, avocat, daikon mariné, oignon vert, feuille de soja, riz sushi, mayonnaise basilic, sauce unagi, pousses",
  },
  {
    category: "Kushiyaki 2 Skewers",
    name: "Teriyaki Glazed Chicken",
    price: 12,
    description: "",
    category_fr: "Kushiyaki 2 Brochettes",
    name_fr: "Poulet Glacé Au Teriyaki",
    description_fr: "",
  },
  {
    category: "Kushiyaki 2 Skewers",
    name: "Ground Chicken Breast",
    price: 12,
    description: "",
    category_fr: "Kushiyaki 2 Brochettes",
    name_fr: "Poitrine De Poulet Hachée",
    description_fr: "",
  },
  {
    category: "Kushiyaki 2 Skewers",
    name: "Unagi - Eel",
    price: 21,
    description: "",
    category_fr: "Kushiyaki 2 Brochettes",
    name_fr: "Unagi - Anguille",
    description_fr: "",
  },
  {
    category: "Kushiyaki 2 Skewers",
    name: "Beef Filet Mignon",
    price: 19,
    description: "",
    category_fr: "Kushiyaki 2 Brochettes",
    name_fr: "Filet Mignon Boeuf",
    description_fr: "",
  },
  {
    category: "Kushiyaki 2 Skewers",
    name: "Shrimp",
    price: 17,
    description: "",
    category_fr: "Kushiyaki 2 Brochettes",
    name_fr: "Crevettes",
    description_fr: "",
  },
  {
    category: "Hot Dishes",
    name: "Fried Chicken With Japanese Kare",
    price: 22,
    description:
      "Panko fried chicken breast, japanese curry sauce, jasmine rice",
    category_fr: "Plats Chauds",
    name_fr:
      "Poitrine de volaille panée au Panko, sauce curry Japonaise, riz au jasmin",
    description_fr: "Morue noire marinée au miso, fleur Myoga.",
  },
  {
    category: "Hot Dishes",
    name: "Chirishibasu/Chilean Sea Bass",
    price: 55,
    description:
      "Chilean sea bass, quinoa, red peppers, edamame, virgin salsa, Ponzu sauce, sprouts.",
    category_fr: "Plats Chauds",
    name_fr: "Chirishibasu/Bar du Chili",
    description_fr:
      "Bar du Chili, quinoa, poivron rouge, edamame, salsa vierge, sauce Ponzu, micro pousses.",
  },
  {
    category: "Hot Dishes",
    name: "Seared Salmon",
    price: 32,
    description:
      "Salmon, teriyaki glazed, asian veggies, asparagus, lemon, sesame oil, sprouts, rice.",
    category_fr: "Plats Chauds",
    name_fr: "Saumon Poêlé",
    description_fr:
      "Saumon, sauce Teriyaki, écume de edamame, asperges, citron, huile de sésame, pousses, riz.",
  },
  {
    category: "Hot Dishes",
    name: "Steak Teriyaki ( New York Strip 10 oz)",
    price: 41,
    description: "Asian greens, vegetable purée, green onion.",
    category_fr: "Plats Chauds",
    name_fr: "Steak Teriyaki ( New York Strip 10 oz)",
    description_fr: "Légumes asiatiques, purée de légumes, oignon vert.",
  },
  {
    category: "Hot Dishes",
    name: "Tofu - Eggplants",
    price: 18,
    description:
      "Fried tofu & eggplants, homemade sweet chili sauce, unagi sauce, sambal oelek sauce, fried taro, micro coriander.",
    category_fr: "Plats Chauds",
    name_fr: "Tofu - Aubergines",
    description_fr:
      "Tofu & aubergines frites, sauce chili sucrée maison, sauce unagi, sauce sambal oelek, taro frit, mini coriandre.",
  },
  {
    category: "Hot Dishes",
    name: "Filet Mignon Stir-fry",
    price: 59,
    description:
      "Grass fed filet mignon, carrots, asparagus, red onions, baby yuchoi, shiitake mushrooms, red peppers, stir-fry sauce.",
    category_fr: "Plats Chauds",
    name_fr: "Sautée de filet mignon",
    description_fr:
      "Filet mignon nourri à l’herbe, carotte, asperges, oignon rouge, Yuchoi mini, champignon shiitake, poivron rouge, sauce stir-fry.",
  },
  {
    category: "Hot Dishes",
    name: "Shrimp Fried Rice",
    price: 28,
    description:
      "Grilled shrimp, rice, carrots, red peppers, zucchini, chili peppers, Ponzu yuzu sauce.",
    category_fr: "Plats Chauds",
    name_fr: "Riz Frit Aux Crevettes",
    description_fr:
      "Crevettes grillées, riz, carotte, poivron rouge, zucchini, piment chili, sauce Ponzu yuzu.",
  },
  {
    category: "Hot Dishes",
    name: "Lobster Fried Rice",
    price: 40,
    description:
      "Tempura battered lobster tail, rice, carrots, red peppers, zucchini, chili peppers, Ponzu yuzu sauce.",
    category_fr: "Plats Chauds",
    name_fr: "Riz Frit Au Homard",
    description_fr:
      "Queue de homard tempura, riz, carotte, poivron rouge, zucchini, piment chili, sauce Ponzu yuzu.",
  },
  {
    category: "Hot Dishes",
    name: "Ramen noodles Chicken (vegetarian - $18)",
    price: 22,
    description:
      "Soft poached egg, ramen noodles, noodle sauce, asian greens, red hot sauce.",
    category_fr: "Plats Chauds",
    name_fr: "Nouilles ramen au poulet (Option végétarienne - 18$)",
    description_fr:
      "Œuf poché à la perfection, nouilles ramen, sauce pour nouilles, légumes asiatiques, sauce piquante rouge.",
  },
  {
    category: "Hot Dishes",
    name: "DAN-DAN beef noodle",
    price: 24,
    description:
      "Crispy caramelized ground beef, sesame chili sauce, Asian greens.",
    category_fr: "Plats Chauds",
    name_fr: "Nouilles au bœuf DAN-DAN",
    description_fr:
      "Boeuf haché caramélisé et croustillant, sauce chili au sésame, légume vert Asiatique.",
  },
  {
    category: "Hot Dishes",
    name: "Chilean Sea Bass",
    price: 56,
    description:
      "Chilean sea bass, red peppers, edamame, bok choy, virgin salsa, Ponzu sauce, sprouts.",
    category_fr: "Plats Chauds",
    name_fr: "Bar Du Chili",
    description_fr:
      "Bar du chili, poivron rouge, edamame, bok choy, sauce vierge, sauce Ponzu, pousses.",
  },
  {
    category: "Hot Dishes",
    name: "Miyazaki A5 Wagyu Steak",
    price: 125,
    description:
      "Miyazaki A5 wagyu sirloin steak, seasonal vegetables, cauliflower purée, wasabi salt, sprouts, gold flakes.",
    category_fr: "Plats Chauds",
    name_fr: "Steak Miyazaki Wagyu A5",
    description_fr:
      "Bifteck de surlonge miyazaki A5 wagyu, légumes de saison, purée de chou-fleur, sel de wasabi, pousses, flocons d’or.",
  },
  {
    category: "Omakase (5 Course)",
    name: "Omakase (5 Course)",
    price: 120,
    description: "",
    category_fr: "Omakase (5 Course)",
    name_fr: "Omakase (5 Course)",
    description_fr: "",
  },
  {
    category: "Extras",
    name: "Sushi rice",
    price: 5,
    description: "",
    category_fr: "Accompagnement",
    name_fr: "Riz sushi",
    description_fr: "",
  },
  {
    category: "Extras",
    name: "Fried Rice",
    price: 8,
    description: "",
    category_fr: "Accompagnement",
    name_fr: "Riz Frit",
    description_fr: "",
  },
  {
    category: "Extras",
    name: "Ginger",
    price: 3,
    description: "",
    category_fr: "Accompagnement",
    name_fr: "Gingembre",
    description_fr: "",
  },
  {
    category: "Extras",
    name: "Sauce",
    price: 3,
    description: "",
    category_fr: "Accompagnement",
    name_fr: "Sauce",
    description_fr: "",
  },
  {
    category: "Desserts",
    name: "Yuzu and Citrus Tart",
    price: 14,
    description:
      "Yuzu cream tart, citrus marmalade with ginger, dark chocolate mousse.",
    category_fr: "Desserts",
    name_fr: "Tarte yuzu et agrumes",
    description_fr:
      "Tarte à la crème de yuzu, marmalade d’agrumes au gingembre, crémeux au chocolat noir.",
  },
  {
    category: "Desserts",
    name: "Passion Fruit Parfait (gluten-free)",
    price: 16,
    description:
      "Passion fruit and mango cakes, mango confit with sake, raspberry mousse.",
    category_fr: "Desserts",
    name_fr: "Parfait  aux fruits de la passion (sans gluten)",
    description_fr:
      "Gâteaux aux fruits de la passion et mangue, confit de mangue au saké, crémeux à la framboise",
  },
  {
    category: "Desserts",
    name: "Mini Chouquettes with Shizo Cream and White Chocolate",
    price: 16,
    description:
      "3 crispy cream puffs filled with white chocolate cream flavored with shiso leaf.",
    category_fr: "Desserts",
    name_fr: "Mini chouquettes à la crème de shizo et chocolat blanc",
    description_fr:
      "3 choux croustillants garnis de crème au chocolat blanc aromatisée à la feuille de shiso.",
  },
  {
    category: "Desserts",
    name: "Matcha and Raspberry Tiramisu",
    price: 16,
    description:
      "Savoyard matcha cookie, mascarpone cream, raspberry coulis, fresh raspberries.",
    category_fr: "Desserts",
    name_fr: "Tiramisu au matcha et framboises",
    description_fr:
      "Biscuit savoyard au matcha, crème mascarpone, coulis de framboises, framboises fraîches.",
  },
  {
    category: "Desserts",
    name: "Assorted Iced Mochis",
    price: 18,
    description: "3 mochis (mango, passion fruit and coconut)",
    category_fr: "Desserts",
    name_fr: "Assortiment de mochis glacés",
    description_fr: "3 mochis (mangue, fruit de la passion et noix de coco)",
  },
];
